import { AssetManager } from "../AssetManager";
import { Game } from "../logic/Game";
import { Enemy } from "../models/Enemy";
import { GameView } from "./GameView";

export class EnemiesView {
    public constructor(
        public game: Game,
        protected assets: AssetManager,
        protected game_view: GameView,
        protected context: CanvasRenderingContext2D,
    ) {

    }

    public update() {
        this.context.imageSmoothingEnabled = false;
        this.game.enemies.forEach((enemy: Enemy) => {
            const image = this.get_enemy_image(enemy);
            const position = this.game.map.get_position_of_path(enemy.progress);

            this.context.drawImage(image,
                position[0] * this.game_view.field_width, position[1] * this.game_view.field_height,
                this.game_view.field_width, this.game_view.field_height
            );
        })
    }

    public get_enemy_image(enemy: Enemy): HTMLImageElement {
        return this.assets.get("units.slime");
    }

}